import React, { memo, useEffect, useRef, useState } from "react";
import "./ShowcasesRecommendRow.scss";

const DEFAULT_COVER = "";
const DEFAULT_AVATAR =
  "https://cvanto-photos.s3.us-east-1.amazonaws.com/DefaultAvatar/avatar.png";

const ShowcasesRecommendRow = memo(function ShowcasesRecommendRow({
  items = [],
  onOpen,
}) {
  const scrollerRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const safeItems = Array.isArray(items) ? items.filter(Boolean) : [];

  const updateScrollState = () => {
    const el = scrollerRef.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    setCanScrollLeft(scrollLeft > 5);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  };

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    updateScrollState();

    el.addEventListener("scroll", updateScrollState);

    window.addEventListener("resize", updateScrollState);

    return () => {
      el.removeEventListener("scroll", updateScrollState);
      window.removeEventListener("resize", updateScrollState);
    };
  }, [safeItems.length]);

  if (!safeItems.length) return null;

  const scrollShowcases = (direction) => {
    const el = scrollerRef.current;
    if (!el) return;

    el.scrollBy({
      left: direction === "left" ? -580 : 580,
      behavior: "smooth",
    });

    setTimeout(updateScrollState, 420);
  };

  return (
    <section className="showcases-row" aria-label="Вітрини продавців">
      <div className="showcases-row__head">
        <div>
          <h3 className="showcases-row__title">Вітрини продавців</h3>
          <p className="showcases-row__subtitle">
            Добірка профілів, товарів і послуг
          </p>
        </div>
      </div>

      <div className="showcases-row__wrap">
        {canScrollLeft && (
          <button
            type="button"
            className="showcases-row__arrow showcases-row__arrow--left"
            onClick={() => scrollShowcases("left")}
            aria-label="Прокрутити вліво"
          >
            ‹
          </button>
        )}

        <div className="showcases-row__scroller" ref={scrollerRef}>
          {safeItems.map((item) => {
            const showcaseId = item.showcaseId || item.id;
            const coverUrl = item.coverUrl || DEFAULT_COVER;
            const title = item.title || "Вітрина";
            const ownerName = item.ownerName || "Користувач";
            const ownerAvatar = item.ownerAvatar || DEFAULT_AVATAR;
            const typeLabel = item.typeLabel || "Вітрина";
            const city = item.city || "";

            const openShowcase = () => {
              if (!showcaseId) return;

              if (typeof onOpen === "function") {
                onOpen(String(showcaseId));
              }
            };

            return (
              <article
                key={showcaseId}
                className="showcases-row__card"
                onClick={openShowcase}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    openShowcase();
                  }
                }}
              >
                <div className="showcases-row__cover">
                  {coverUrl ? (
                    <img src={coverUrl} alt={title} loading="lazy" />
                  ) : (
                    <div className="showcases-row__cover-ph">
                      <span>{typeLabel}</span>
                    </div>
                  )}

                  <div className="showcases-row__type">{typeLabel}</div>
                </div>

                <div className="showcases-row__body">
                  <div className="showcases-row__seller">
                    <img
                      src={ownerAvatar}
                      alt=""
                      className="showcases-row__avatar"
                      loading="lazy"
                    />

                    <div className="showcases-row__seller-text">
                      <div className="showcases-row__seller-name">
                        {ownerName}
                      </div>

                      {city && (
                        <div className="showcases-row__city">{city}</div>
                      )}
                    </div>
                  </div>

                  <h4 className="showcases-row__card-title">{title}</h4>
                </div>
              </article>
            );
          })}
        </div>

        {canScrollRight && (
          <button
            type="button"
            className="showcases-row__arrow showcases-row__arrow--right"
            onClick={() => scrollShowcases("right")}
            aria-label="Прокрутити вправо"
          >
            ›
          </button>
        )}
      </div>
    </section>
  );
});

export default ShowcasesRecommendRow;